import ArticleReviewer from '../components/article-reviewer'

export default function ArticleReviewPage() {
  return <ArticleReviewer />
}
